// Add your custom JS here.

// import Swiper JS
import Swiper from 'swiper/bundle';

window.addEventListener('load', function () {

    function addExternalLinkAttr() {
        //ページのドメインを取得
        const domain = window.location.hostname;
        //取得したドメインを検証対象に指定
        const regexp = new RegExp(domain);

        //ページ内に存在する全てのa要素が対象
        const elements = document.getElementsByTagName('a');

        for (let element of elements) {
            //a要素のhref（リンク）を取得
            let href = element.getAttribute('href');

            // element.parentNode.insertBefore(href+' : '+domain, element.nextElementSibling);

            //a要素のhref（リンク）にドメインが含まれていなければ
            if (!regexp.test(href) && /^https?:\/\//i.test(href)) {
                //a要素にtarget="_blank"を追加する
                element.setAttribute('target', '_blank');
                //a要素にrel="noopener"を追加する
                element.setAttribute('rel', 'noopener');
            }
        }

    }

    addExternalLinkAttr();

    function setActiveLinkTheme() {

        const navLinks   = document.querySelectorAll('.nav-tabs a.nav-link');
        const currentURL = window.location.href;
        const savedURL   = sessionStorage.getItem('activeNavLink');

        if (navLinks.length > 0) {
            // ページ内の.nav-linkが存在する場合
            if (savedURL) {
                // sessionStorageに保存されたURLがある場合
                const matchingLink = Array.from(navLinks).find(link => link.getAttribute('href') === currentURL);

                if (matchingLink) {
                    // 現在のURLと一致する.nav-linkがある場合
                    matchingLink.classList.add('active');
                    sessionStorage.setItem('activeNavLink', currentURL);
                } else {
                    // 現在のURLと一致しない場合、sessionStorageに保存されたURLを探す
                    const savedLink = Array.from(navLinks).find(link => link.getAttribute('href') === savedURL);

                    if (savedLink) {
                        savedLink.classList.add('active');
                    } else {
                        // sessionStorageに保存されたURLがない場合、最初の.nav-linkに.activeを付与
                        navLinks[0].classList.add('active');
                        sessionStorage.setItem('activeNavLink', navLinks[0].getAttribute('href'));
                    }
                }
            } else {
                // sessionStorageに保存されたURLがない場合、最初の.nav-linkに.activeを付与
                navLinks[0].classList.add('active');
                sessionStorage.setItem('activeNavLink', navLinks[0].getAttribute('href'));
            }
        }
    }

    setActiveLinkTheme();

});

const swiperFrontToday = new Swiper('.front-schedule-today.swiper', {

    effect: "flip",
    grabCursor: true,
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    loop: true,
});

const swiperFrontListReleased = new Swiper('.front-schedule-list-released.swiper', {
    slidesPerView: 1,
    spaceBetween: 15,
    grabCursor: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    loop: true,
    scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
    },
    breakpoints: {
        758: {
            slidesPerView: 2,
            spaceBetween: 15,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
});

const swiperfrontExternal = new Swiper('.front-external .swiper', {
    centeredSlides: true,
    grabCursor: true,
    slidesPerView: 1.5,
    spaceBetween: 10,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
        758: {
            centeredSlides: true,
            grabCursor: true,
            slidesPerView: 1.75,
            spaceBetween: 10,
        },
        992: {
            centeredSlides: false,
            grabCursor: true,
            slidesPerView: 3,
            spaceBetween: 10,
        },
        1400: {
            centeredSlides: false,
            grabCursor: false,
            slidesPerView: 4,
            spaceBetween: 15,
        },
    },
});